import { render, staticRenderFns } from "./ProductForm.vue?vue&type=template&id=0c699cd4&scoped=true&"
import script from "./ProductForm.vue?vue&type=script&lang=js&"
export * from "./ProductForm.vue?vue&type=script&lang=js&"
import style0 from "./ProductForm.vue?vue&type=style&index=0&id=0c699cd4&prod&scoped=true&lang=css&"
import style1 from "./ProductForm.vue?vue&type=style&index=1&id=0c699cd4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c699cd4",
  null
  
)

export default component.exports